import { createEntityHooks } from '../core/createEntityHooks'
import type { BaseDocument } from '../core/types'

export interface CycleDocument extends BaseDocument {
  projectId: string
  name: string
  number: number
  startDate: number
  endDate: number
  status: 'draft' | 'active' | 'completed'
  description: string | null
  completedOn: number | null
  completedBy: string | null
}

const hooks = createEntityHooks<CycleDocument>('cycles')

export const useCycles = (filter?: Partial<CycleDocument>) => {
  const { data, isLoading, db } = hooks.useEntities(filter)
  return { cycles: data, isLoading, db }
}

export const useCycle = (id: string | undefined) => {
  const { data, isLoading } = hooks.useEntity(id)
  return { cycle: data, isLoading }
}

export const useProjectCycles = (projectId: string | undefined) => {
  const { cycles, isLoading, db } = useCycles()
  const projectCycles = projectId
    ? cycles?.filter((c) => c.projectId === projectId && !c.isDeleted) ?? null
    : null
  return { cycles: projectCycles, isLoading, db }
}

export const useActiveCycle = (projectId: string | undefined) => {
  const { cycles, isLoading } = useProjectCycles(projectId)
  const activeCycle = cycles?.find((c) => c.status === 'active') ?? null
  return { activeCycle, isLoading }
}

export const useCycleMutations = () => {
  const { create, update, delete: deleteEntity } = hooks.useMutations()
  return {
    createCycle: create,
    updateCycle: update,
    deleteCycle: deleteEntity,
  }
}
